<section #containerAbout id="containerAbout" class="section about active">


  <!-- Wrapper-Panel -->
  <div class="wrapper-about-panel" #wrapper>

    <!-- Detail-Panel -->
    <div class="details-panel" id="details">
      <div class="scroll-bleed" #aboutDetailsScroll>
        <div class="close-btn-wrapper">
          <button class="close-btn" (click)="closeDetail()">✕</button>
        </div>
        <div class="details-content">

          <div class="more-info">
            <h3 data-translate="ABOUT.DETAILS.MISSION.TITLE"></h3>
            <p data-translate="ABOUT.DETAILS.MISSION.TEXT"></p>
            <br>
            <h3 data-translate="ABOUT.DETAILS.VALUES.TITLE"></h3>
            <p data-translate="ABOUT.DETAILS.VALUES.TEXT"></p>
            <br>
            <h3 data-translate="ABOUT.DETAILS.PROCESS.TITLE"></h3>
            <ol class="details-list">
              <li data-translate="ABOUT.DETAILS.PROCESS.PROCESS_STEP1"></li>
              <li data-translate="ABOUT.DETAILS.PROCESS.PROCESS_STEP2"></li>
              <li data-translate="ABOUT.DETAILS.PROCESS.PROCESS_STEP3"></li>
              <li data-translate="ABOUT.DETAILS.PROCESS.PROCESS_STEP4"></li>
            </ol>
            <br>
            <h3 data-translate="ABOUT.DETAILS.BEHIND_THE_SCENES.TITLE"></h3>
            <p data-translate="ABOUT.DETAILS.BEHIND_THE_SCENES.TEXT"></p>
            <br>
            <p data-translate="ABOUT.DETAILS.NEXT_STEPS"></p>
            <br>
            <br>
          </div>
        </div>
      </div>


    </div>


    <!-- Intro-Panel -->
    <div class="intro-panel" id="intro">
      <div class="img-wrapper">
        <div class="img-box about-img">
          <img [src]="delayedImageSrc">
        </div>
      </div>

      <div class="about-info">
        <h2 class="title">About Us</h2>
        <h3>Marc Wieland &lt;/Software &amp; Consulting&gt;.</h3>
        <p class="desc" data-translate="ABOUT.BIO"></p>
        <a href="#" class="btn view-more-btn" data-translate="ABOUT.MORE_BTN"
          (click)="toggleDetails(); $event.preventDefault()"></a>
      </div>
    </div>
  </div>

  <app-footer (toggleImprint)="toggleImprint.emit()" (togglePrivacy)="togglePrivacy.emit()"></app-footer>

</section>
